import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { teknikTokens, teknikButtons } from '../styles/teknik-tokens.js';
import { tkPrimitives } from '../styles/tk-primitives.js';
import { tkAuthCard } from '../styles/tk-auth.js';

@customElement('app-forgot-password')
export class AppForgotPassword extends LitElement {
  @state() email = '';
  @state() loading = false;
  @state() submitted = false;
  @state() error = '';

  async handleSubmit(e: Event) {
    e.preventDefault();
    this.error = '';
    this.loading = true;
    try {
      const res = await fetch('/auth/teknik/forgot-password', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: this.email }),
      });
      const data = await res.json();
      if (!res.ok) { this.error = data.error || "That didn't go through. Try again."; }
      else { this.submitted = true; }
    } catch { this.error = "Couldn't reach Teknik. Check your connection and try again."; }
    this.loading = false;
  }

  static styles = [teknikTokens, teknikButtons, tkPrimitives, tkAuthCard, css``];

  render() {
    return html`
      <main>
        <div class="card">
          <div class="eyebrow">Password reset</div>
          <h1 class="title">Forgot your password?</h1>
          <p class="sub">Give us the email on your account and we'll send a reset link.</p>

          ${this.error ? html`<div class="tk-flash err" style="margin-bottom:1rem">${this.error}</div>` : ''}

          ${this.submitted
            ? html`<div class="tk-flash ok">
                If that email is registered, a reset link is on its way. Check your inbox,
                and your spam folder.
              </div>`
            : html`
                <form @submit=${this.handleSubmit}>
                  <div class="field">
                    <label class="tk-label" for="email">Email</label>
                    <input
                      id="email"
                      class="tk-input"
                      type="email"
                      placeholder="you@example.com"
                      autocomplete="email"
                      required
                      .value=${this.email}
                      @input=${(e: any) => (this.email = e.target.value)}
                    />
                  </div>
                  <button class="tk-btn primary full" type="submit" ?disabled=${this.loading}>
                    ${this.loading ? 'Sending…' : 'Send reset link'}
                  </button>
                </form>
              `}

          <div class="foot"><a href="/login">Back to sign in</a></div>
        </div>
      </main>
    `;
  }
}
